/**
 * Fungsi noise GLSL yang disisipkan ke liquid-glass.frag lewat penanda.
 *
 * Ditulis sebagai string TS, bukan berkas `.glsl?raw`: impor `?raw` hanya
 * dipahami Vite (dev), sedangkan build produksi memakai `bun build` yang
 * gagal meresolvenya. Isi string di bawah harus tetap GLSL apa adanya
 * (`#version` harus di awal string, tanpa baris kosong di depan).
 */
export const NOISE_GLSL = `// Noise hash 3D murni (tanpa tekstur) — disisipkan ke fragment shader liquid
// glass lewat orb-webgl-shaders.ts. Sama persis dengan teknik yang sudah
// terbukti di prototipe _refs/jenna-orb/prototype/orb-liquid-glass-prototype.html.
float hash(vec3 p) {
  p = fract(p * 0.3183099 + 0.1);
  p *= 17.0;
  return fract(p.x * p.y * p.z * (p.x + p.y + p.z));
}

float vnoise(vec3 x) {
  vec3 i = floor(x);
  vec3 f = fract(x);
  f = f * f * (3.0 - 2.0 * f);
  return mix(
    mix(
      mix(hash(i + vec3(0, 0, 0)), hash(i + vec3(1, 0, 0)), f.x),
      mix(hash(i + vec3(0, 1, 0)), hash(i + vec3(1, 1, 0)), f.x),
      f.y
    ),
    mix(
      mix(hash(i + vec3(0, 0, 1)), hash(i + vec3(1, 0, 1)), f.x),
      mix(hash(i + vec3(0, 1, 1)), hash(i + vec3(1, 1, 1)), f.x),
      f.y
    ),
    f.z
  );
}

float fbm(vec3 p) {
  float v = 0.0;
  float a = 0.5;
  for (int i = 0; i < 4; i++) {
    v += a * vnoise(p);
    p *= 2.02;
    a *= 0.5;
  }
  return v;
}
`;
